import React, { useEffect, useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { getExamCatesByLanguage } from '../../services/apiService';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useAuth } from '../../contexts/AuthContext';
import { 
  Card,
  Text,
  Title1,
  Button,
  tokens,
} from '@fluentui/react-components';
import { FaChevronRight, FaClipboardList } from 'react-icons/fa';

const useStyles = makeStyles({
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 24px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
  },
  headerIcon: {
    fontSize: '48px',
    color: '#0078d4',
    marginBottom: '16px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '600',
    color: '#323130',
    margin: 0,
  },
  subtitle: {
    fontSize: '16px',
    color: '#605e5c',
    maxWidth: '600px',
    textAlign: 'center',
  },
  examGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '24px',
  },
  examCard: {
    padding: '24px',
    backgroundColor: '#fff',
    border: '1px solid #edebe9',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
      borderColor: '#0078d4',
    },
  },
  examTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#323130',
    margin: 0,
    flex: 1,
  },
  examFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '8px',
  },
  startButton: {
    backgroundColor: '#0078d4',
    color: '#fff',
    padding: '8px 16px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '500',
    '&:hover': {
      backgroundColor: '#106ebe',
    },
  },
  chevronIcon: {
    fontSize: '14px',
  },
});

export default function ExamCategories() {
  const styles = useStyles();
  const { user } = useAuth();
  const { t } = useTranslation(['dashboard']);
  const [exams, setExams] = useState([]);

  useEffect(() => {
    document.title = t('headers:exams');
  }, []);

  useEffect(() => {
    fetchExams();
  }, [i18next.language]);

  const fetchExams = async () => {
    const exams = await getExamCatesByLanguage(i18next.language, user.moduleId);
    setExams(exams);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FaClipboardList className={styles.headerIcon} />
        <Title1 className={styles.title}>{t('dashboard:exam-list')}</Title1>
        <Text className={styles.subtitle}>
          Aşağıdaki sınavlardan birini seçerek pratik yapmaya başlayabilirsiniz.
        </Text>
      </div>

      <div className={styles.examGrid}>
        {exams.map((exam) => (
          <Link 
            key={exam.id} 
            to={`/exam/${exam.id}`} 
            style={{ textDecoration: 'none' }}
          >
            <Card className={styles.examCard}>
              <Text className={styles.examTitle}>
                {exam.name}
              </Text>
              <div className={styles.examFooter}>
                <Button 
                  className={styles.startButton}
                  appearance="primary"
                >
                  Sınava Başla
                  <FaChevronRight className={styles.chevronIcon} />
                </Button>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
